"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var react_1 = __importDefault(require("react"));
var react_loading_overlay_ts_1 = __importDefault(require("react-loading-overlay-ts"));
var Spinner = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_loading_overlay_ts_1.default, { styles: {
            wrapper: function (base) { return (__assign({}, base)); },
            overlay: function (base) { return (__assign(__assign({}, base), { background: '#e9e9e9' })); },
            content: function (base) { return (__assign(__assign({}, base), { color: '#6f777b', fontSize: 'smaller', fontFamily: 'Montserrat' })); },
            spinner: function (base) { return (__assign(__assign({}, base), { width: '30px', margin: '0px auto 5px auto', '& svg circle': {
                    stroke: '#00bec0',
                } })); },
        }, active: props.isLoading, spinner: true, text: props.loadingText || 'Please wait...' }, children));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map